import { breakpointAtLeast, throttle, videoLoad } from './utils.js';

(function ($) {
  // Load videos, only on devices larger than 'medium'
  $.each($('.js-pillars-video'), function () {
    var $currentVideo = $(this);

    if ($currentVideo.length) {
      // Load video on resize
      $(window).on(
        'resize',
        throttle(function () {
          videoLoad($currentVideo);
        }, 10),
      );

      // Load video on page load
      videoLoad($currentVideo);
    }
  });

  // Autoplay video in first pillar when scrolled to it
  let coverageAreaTriggered = false;
  let wpVideo = $('.js-pillars-video--1');
  if (wpVideo.length > 0 && breakpointAtLeast('medium')) {
    $(window).on(
      'scroll',
      throttle(function () {
        if (!coverageAreaTriggered) {
          let scrollTop = $(window).scrollTop(),
            windowHeight = $(window).height(),
            elem = wpVideo.offset().top + 350,
            final = elem - windowHeight,
            distance = final - scrollTop;
          if (distance < 0) {
            // Do we need it? We have it muted in html
            // wpVideo.get(0).muted = true;
            wpVideo.get(0).play();
            coverageAreaTriggered = true;
          }
        }
      }, 100),
    );
  }

  // Play video when switching pillar tab
  $('.bbc-wb-pillars__tabs-nav-btn').on('click', function () {
    const $video = $('.js-pillars-video');
    const $currentVideo = $('.js-pillars-video--' + $(this).data('index'));
    if ($currentVideo.length > 0 && breakpointAtLeast('medium')) {
      // Play current and pause others
      $video.get(0).pause();
      $currentVideo.get(0).play();
    }
  });
})(jQuery);
